import { newE2EPage } from "@stencil/core/testing";

describe("redirect", () => {
    it("should have the class hydrated", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-redirect url="/" delay="33"></ux-redirect>`);
        const el = await page.find("ux-redirect");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
    });
});
